import React, { useState } from 'react';

import { LongFormTextModalContext, VideoModalContext, MapModalContext, CommentFormModalContext, PosterModalContext, GalleryModalContext, CustomFormModalContext } from '../utils/contexts';
import LongFormTextModal from './modals/long-form-text-modal';
import VideoEmbedModal from './modals/video-embed-modal';
import MapModal from './modals/map-modal';
import CommentFormModal from './modals/comment-form-modal';
import GalleryModal from './modals/gallery-modal';
import PosterModal from './modals/poster-modal';
import CustomFormModal from './modals/custom-form-modal';

export default function ModalsWrapper({ children }) {

	const [ isLongFormTextModalOpen, setLongFormTextModalOpen ] = useState(false);
	const [ longFormTextTitle, setLongFormTextTitle ] = useState('Some Title');
	const [ longFormTextMarkdown, setLongFromTextMarkdown ] = useState('# Hello World');

	const [ isVideoEmbedModalOpen, setVideoEmbedModalOpen ] = useState(false);
	const [ videoEmbedUrl, setVideoEmbedUrl ] = useState('https://www.youtube.com/watch?v=dQw4w9WgXcQ');

	const [ isMapModalOpen, setMapModalOpen ] = useState(false);
	const [ mapCenter, setMapCenter ] = useState({
		lat: 55.8681772,
		lng: -4.2783594
	});

	const [ isCommentFormModalOpen, setCommentFormModalOpen ] = useState(false);
	const [ commentFormPostUrl, setCommentFormPostUrl ] = useState('');

	const [ isGalleryModalOpen, setGallerModalOpen ] = useState(false);
  const [ galleryModalImages, setGalleryModalImages ] = useState([]);
  const [ galleryModalMarkdownCaptions, setGalleryModalMarkdownCaptions ] = useState([]);
  const [ galleryModalStyle, setGalleryModalStyle ] = useState({});

	const [ isPosterModalOpen, setPosterModalOpen ] = useState(false);
  const [ posterModalImage, setPosterModalImage ] = useState('');
  const [ posterPdfLink, setPosterPdfLink ] = useState(null);
	const [ posterLinkText, setPosterLinkText ] = useState(null);
  const [ posterExtraButtons, setPosterExtraButtons ] = useState([]);
	const [ posterZoomPan, setPosterZoomPan ] = useState(true);
	const [ posterExtraWide, setPosterExtraWide ] = useState(false);

  const [ isCustomFormModalOpen, setCustomFormModalOpen ] = useState(false);
  const [ customFormModalTitle, setCustomFormModalTitle ] = useState('');
  const [ customFormModalAction, setCustomFormModalAction ] = useState('');
  const [ customFormModalMethod, setCustomFormModalMethod ] = useState('POST');
  const [ customFormModalPartsConfig, setCustomFormModalPartsConfig ] = useState([]);

	// Contexts
	const longFormTextModalContextValue = {
		title: longFormTextTitle,
		isOpen: isLongFormTextModalOpen,
		markdown: longFormTextMarkdown,
		setIsOpen: (isOpen=false) => setLongFormTextModalOpen(isOpen),
		setTitle: (title=' -- ') => setLongFormTextTitle(title), 
		setMarkdown: (markdown='# Hello World') => setLongFromTextMarkdown(markdown)
	};

	const videoEmbedModalContextValue = {
		isOpen: isVideoEmbedModalOpen,
		url: videoEmbedUrl,
		setIsOpen: (isOpen=false) => setVideoEmbedModalOpen(isOpen),
		setUrl: (url='https://www.youtube.com/watch?v=dQw4w9WgXcQ') => setVideoEmbedUrl(url),
	};

	const mapModalContextValue = {
		isOpen: isMapModalOpen,
		center: mapCenter,
		setIsOpen: (isOpen=false) => setMapModalOpen(isOpen),
		setCenter: (lat=55.8681772, lng=-4.2783594) => setMapCenter({ lat, lng }),
	};

	const commentFormModalContextValue = {
		isOpen: isCommentFormModalOpen,
		postUrl: commentFormPostUrl,
		setIsOpen: (isOpen=false) => setCommentFormModalOpen(isOpen),
		setPostUrl: (postUrl='') => setCommentFormPostUrl(postUrl)
	};

	const galleryModalContextValue = {
		isOpen: isGalleryModalOpen,
    images: galleryModalImages,
    markdownCaptions: galleryModalMarkdownCaptions,
    modalStyle: galleryModalStyle,
		setIsOpen: (isOpen=false) => setGallerModalOpen(isOpen),
    setImages: (images=[]) => setGalleryModalImages(images),
    setMarkdownCaptions: (markdownCaptions=[]) => setGalleryModalMarkdownCaptions(markdownCaptions),
    setModalStyle: (style={}) => setGalleryModalStyle(style),
	};

	const posterModalContextValue = {
		isOpen: isPosterModalOpen,
    image: posterModalImage,
    pdfLink: posterPdfLink,
		linkText: posterLinkText,
		zoomPan: posterZoomPan,
		extraWide: posterExtraWide,
    extraButtons: posterExtraButtons,
		setIsOpen: (isOpen=false) => setPosterModalOpen(isOpen),
    setImage: (image='') => setPosterModalImage(image),
    setPdfLink: (pdfLink) => setPosterPdfLink(pdfLink),
		setLinkText: (linkText) => setPosterLinkText(linkText),
    setExtraButtons: (extraButtons) => setPosterExtraButtons(extraButtons),
		setZoomPan: (zoomPan=true) => setPosterZoomPan(zoomPan),
		setExtraWide: (extraWide=false) => setPosterExtraWide(extraWide),
  }
  
  const customFormModalContextValue = {
    isOpen: isCustomFormModalOpen,
    title: customFormModalTitle,
    action: customFormModalAction,
    method: customFormModalMethod,
    partsConfig: customFormModalPartsConfig,
    setIsOpen: (isOpen=false) => setCustomFormModalOpen(isOpen),
    setTitle: (title='') => setCustomFormModalTitle(title),
    setAction: (action='') => setCustomFormModalAction(action),
    setMethod: (method='POST') => setCustomFormModalMethod(method),
    setPartsConfig: (partsConfig=[]) => setCustomFormModalPartsConfig(partsConfig),
  };

	return(
		<LongFormTextModalContext.Provider value={longFormTextModalContextValue} >
			<VideoModalContext.Provider value={videoEmbedModalContextValue} >
				<MapModalContext.Provider value={mapModalContextValue} >
					<CommentFormModalContext.Provider value={commentFormModalContextValue} >
						<GalleryModalContext.Provider value={galleryModalContextValue} >
							<PosterModalContext.Provider value={posterModalContextValue} >
                <CustomFormModalContext.Provider value={customFormModalContextValue}>
                  {children}
                  <LongFormTextModal />
                  <VideoEmbedModal />
                  <MapModal />
                  <CommentFormModal />
                  <GalleryModal />
                  <PosterModal />
                  <CustomFormModal />
                </CustomFormModalContext.Provider>
							</PosterModalContext.Provider>
						</GalleryModalContext.Provider>
					</CommentFormModalContext.Provider>
				</MapModalContext.Provider>
			</VideoModalContext.Provider>
		</LongFormTextModalContext.Provider>
	);
}